export default __webpack_public_path__ + "static/media/pdfAlap.8ebf334c.jpg";